import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { FormBuilder, FormControl } from '@angular/forms';
import { FormValidations } from '../../../shared/form-validation/form-validation';
import { Title } from '@angular/platform-browser';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { ReturnNativeService } from '../../../shared/service/comunicator-native/return-native/return-native';
import { AnalycticsNativeService } from '../../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { Keyboard, KeyboardResizeMode } from '@awesome-cordova-plugins/keyboard/ngx';
import { ProfileDataService } from '../../service/profile-data.service';
import { AnalyticsPageModel } from '../../../shared/model/analyticsPage';
import { AnalyticsPageService } from '../../../shared/service/analytics/analytics-page.service';
import { AnalyticsGA4PagesModel } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models';
import { AnalyticsGA4PageService } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss'],
})
export class EmailComponent extends DefaultPageComponent implements OnInit {

  public email = '';
  public emailRepeated = '';
  public idComponentName = 'documentEmail';
  public idComponentNameRepeated = 'documentEmailRepeated';
  placeholder = 'e-mail@exemplo.com.br';
  placeholderConfirm = 'Confirme seu e-mail';
  error = false;
  errorRepeated = false;
  buttonEnable = false;
  textError = '';
  textErrorRepeated = '';
  invalidErrorText = 'Email inválido';
  invalidErrorRepeatedText = 'Esses campos não coincidem. Tente novamente';
  maxLengthErrorText = 'Limite de caracteres alcançado';
  cacheNative: any;
  idLabel = 'emailDoc';
  label = 'E-mail';
  startStage = '';
  endStage = '';
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  hideSecondInput = true;
  editInput = false;

  emailForm = this.formBuilder.group({
    docEmail: this.formBuilder.control('', [FormValidations.validationEmail]),
    docEmailRepeated: this.formBuilder.control('')
  });

  headerId = 'page-email';
  titlePage = 'Dados de contato';

  constructor(
    public router: NavController,
    private profileDataService: ProfileDataService,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private formBuilder: FormBuilder,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private keyBoard: Keyboard,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.getTrack();
    this.keyBoard.setResizeMode(KeyboardResizeMode.Body);
  }

/* istanbul ignore next */
  get docEmail() { return this.emailForm.get('docEmail'); }

  /* istanbul ignore next */
  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest('email', 'email', 'profileData');
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.checkHideSecondInput();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  ionViewWillLeave() {
    this.hideSecondInput = true;
    this.editInput = false;
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = 'profile';

    this.startStage = (track.getIndexPage(this.headerId, path)).toString();
    this.endStage = (track.getTotalPage(path)).toString();
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.email;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathEmail,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl)
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    /* tslint:disable:no-string-literal */
    this.profileDataService.setDocumentEmailData(this.email.toLowerCase());
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = 'Clique';
    const it_complementary = {
              it_eventaction: this.analyticsPage.action,
              it_eventlabel: this.analyticsPage.back,
              it_pagename: this.analyticsPage.email
           };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  getPageId(): string {
    return this.headerId;
  }

  errorMsg() {
    const control = this.emailForm.get('docEmail') as FormControl;
    this.error = control.errors !== null;

    this.error ? this.buttonEnable = false : this.buttonEnable = true;

    if (control.errors !== null && control.errors.hasOwnProperty('email')) {
      return this.textError = this.invalidErrorText;
    } else if (control.errors !== null && control.errors.hasOwnProperty('caracterLength')) {
      return this.textError = this.invalidErrorText;
    } else {
      this.textError = '';
    }
    if (this.email.toLowerCase() !== this.emailRepeated.toLowerCase() && this.editInput) {
      this.errorRepeated = true;
      this.buttonEnable = false;
      this.textErrorRepeated = this.invalidErrorRepeatedText;
    } else {
      this.errorRepeated = false;
      this.textErrorRepeated = '';
    }
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  checkHideSecondInput() {
    if (this.journeyService.registratioJourney.data.profileData?.email?.length > 1) {
      this.hideSecondInput = true;
    } else {
      this.hideSecondInput = false;
    }
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.profileData?.email?.length > 1) {
      this.email = this.journeyService.registratioJourney.data.profileData.email;
      this.emailForm.controls.docEmail.setValue(this.journeyService.registratioJourney.data.profileData.email);
      this.emailRepeated = '';
      this.emailForm.controls.docEmailRepeated.setValue('');
      this.editInput = false;
      this.errorMsg();
    }
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }

}


